import { useSelector } from "react-redux";
import * as CONST from "./actionTypes";

const intialState = {
  isLogin: false,
  loading: false,
  token: (localStorage && localStorage.getItem("token")) || null,
  _id: (localStorage && localStorage.getItem("_id")) || null,
  profileImage: (localStorage && localStorage.getItem("profileImage")) || "",
  name: (localStorage && localStorage.getItem("name")) || "",
  email: (localStorage && localStorage.getItem("email")) || "",
};

const LoginReducer = (state = intialState, { type, payload }) => {
  switch (type) {
    case CONST.LOGIN_ADMIN:
      return {
        ...state,
        loading: true,
      };
    case CONST.LOGIN_ADMIN_SUCCESS:
      return {
        ...state,
        isLogin: true,
        loading: false,
        token: payload.token,
        _id: payload?.data?._id,
        profileImage: payload?.data?.profileImage,
        name: payload?.data?.name,
        email: payload?.data?.email,
      };
    case CONST.LOGIN_ADMIN_FAIL:
      return {
        ...state,
        loading: false,
        isLogin: false,
        token: null,
        _id: null,
      };

    case CONST.LOGOUT_ADMIN:
      return {
        ...state,
        loading: false,
        isLogin: false,
        token: null,
        _id: null,
      };

    // case CONST.UPDATE_PROFILE:
    //   localStorage.setItem("profileImage", payload?.profileImage?.link);
    //   localStorage.setItem("name", payload?.name);
    //   localStorage.setItem("email", payload?.email);
    //   return {
    //     ...state,
    //     profileImage: payload?.profileImage?.link,
    //     name: payload?.name,
    //     email: payload?.email,
    //   };

    default:
      return state;

      break;
  }
};

export default LoginReducer;
